/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsOutCardinal(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M163.6748,200.6543a7.99949,7.99949,0,0,1-1.73339,8.71826l-28.28418,28.28418a8.00063,8.00063,0,0,1-11.31446,0L94.05859,209.37256a8.00038,8.00038,0,0,1,5.65723-13.65674H120V160a8,8,0,0,1,16,0v35.71582h20.28418A8,8,0,0,1,163.6748,200.6543ZM99.71582,60.28418H120V96a8,8,0,0,0,16,0V60.28418h20.28418a8.00038,8.00038,0,0,0,5.65723-13.65674L133.65723,18.34326a8.00063,8.00063,0,0,0-11.31446,0L94.05859,46.62744a8.00038,8.00038,0,0,0,5.65723,13.65674ZM96,136a8,8,0,0,0,0-16H60.28418V99.71582A8.00038,8.00038,0,0,0,46.627,94.05859L18.34277,122.34326a8,8,0,0,0,0,11.31348L46.627,161.94141a8.00038,8.00038,0,0,0,13.65723-5.65723V136Zm141.65723-13.65674L209.37305,94.05859a8.00038,8.00038,0,0,0-13.65723,5.65723V120H160a8,8,0,0,0,0,16h35.71582v20.28418a8.00018,8.00018,0,0,0,13.65723,5.65723l28.28418-28.28467A8,8,0,0,0,237.65723,122.34326Z" />
    </Svg>
  );
}

export default ArrowsOutCardinal;
